import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Constants } from '../../../common/constants';
import { FormComponentBase } from '../../../common/form-component-base';
import { Global } from '../../../common/global';
import { StaticDataService } from '../../../services/api/static-data.service';
var CompanyDataComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyDataComponent, _super);
    function CompanyDataComponent(staticDataService) {
        var _this = _super.call(this) || this;
        _this.staticDataService = staticDataService;
        _this.warningHasBeenShown = false;
        _this.childIsValid = Array(3).fill(true);
        _this.childIsDirty = Array(9).fill(false);
        return _this;
    }
    Object.defineProperty(CompanyDataComponent.prototype, "resetChildFrom", {
        set: function (value) {
            if (value) {
                this.childIsValid = Array(3).fill(true);
                this.childIsDirty = Array(9).fill(false);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyDataComponent.prototype, "branding", {
        get: function () {
            return environment.branding;
        },
        enumerable: true,
        configurable: true
    });
    CompanyDataComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.staticDataService.CompanyType.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
            return (_this.taxCategories = data);
        });
        this.staticDataService.DefaultTaxTable.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (data) {
            _this.taxTables = data.filter(function (taxTable) {
                return taxTable.Id < 98;
            });
            return _this.taxTables;
        });
        this.editModeChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function () { return (_this.warningHasBeenShown = false); });
        this.isDirtyChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (dirty) {
            if (_this.company && !dirty && !_this.editMode) {
                _this.originalBankAccountNo = _this.company.BankAccountNo;
            }
        });
    };
    CompanyDataComponent.prototype.onBankAccountNoChanged = function () {
        if (this.editMode && this.company && this.company.HasNetsAgreement && !this.warningHasBeenShown) {
            this.isWarningVivible = true;
        }
        this.onChange();
    };
    Object.defineProperty(CompanyDataComponent.prototype, "isGreenland", {
        get: function () {
            return Global.COMPANY && Global.COMPANY.CountryId === Constants.GREENLAND_COUNTRY_ID;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyDataComponent.prototype, "IsSwedenCompany", {
        get: function () {
            return Global.COMPANY && Global.COMPANY.CountryId === Constants.SWEDEN_COUNTRY_ID;
        },
        enumerable: true,
        configurable: true
    });
    CompanyDataComponent.prototype.onWarningAction = function (action) {
        if (action !== 'Understood') {
            this.company.BankAccountNo = this.originalBankAccountNo;
        }
        else {
            this.onChange();
        }
        this.warningHasBeenShown = true;
    };
    return CompanyDataComponent;
}(FormComponentBase));
export { CompanyDataComponent };
